(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-catering-funnel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-funnel')) {
    const RECAP_KEY = 'mc-catering-recap';
    const KLAVIYO_KEY = 'mc-catering-klaviyo';
    const LEAD_KEY = 'mc-catering-lead';
    const LEAD_SENT_KEY = 'mc-catering-lead-sent';
    const START_KEY = 'mc-catering-start';
    const CLICK_KEY = 'mc-ads-click';
    const DAY = 86400000;
    const designMode = () => Boolean(window.Shopify && window.Shopify.designMode);
    const cookie = (name) => {
      const hit = document.cookie.split('; ').find((entry) => entry.startsWith(`${name}=`));
      return hit ? decodeURIComponent(hit.slice(name.length + 1)) : '';
    };
    const uuid = () => {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
        const random = (Math.random() * 16) | 0;
        return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
      });
    };

    // Ad tags for the catering pages only. Loaded once per page load, never a PageView:
    // the Facebook and Google channels already send those from Shopify's pixel sandbox.
    const ads = {
      loaded: false,
      load(cfg, matching) {
        if (this.loaded || !cfg || !cfg.track || designMode()) return;
        this.loaded = true;
        try {
          if (cfg.metaPixel && /^\d{6,20}$/.test(cfg.metaPixel)) this.loadMeta(cfg.metaPixel, matching);
        } catch (error) {}
        try {
          const ids = [cfg.googleAds, cfg.ga4].filter((id) => id && /^(AW|G)-[\w-]+$/.test(id));
          if (ids.length) this.loadGoogle(ids);
        } catch (error) {}
      },
      loadMeta(id, matching) {
        if (!window.fbq) {
          const queue = function () {
            if (queue.callMethod) queue.callMethod.apply(queue, arguments);
            else queue.queue.push(arguments);
          };
          queue.push = queue;
          queue.loaded = true;
          queue.version = '2.0';
          queue.queue = [];
          window.fbq = queue;
          if (!window._fbq) window._fbq = queue;
          const script = document.createElement('script');
          script.async = true;
          script.src = 'https://connect.facebook.net/en_US/fbevents.js';
          document.head.appendChild(script);
        }
        window.fbq('set', 'autoConfig', false, id);
        if (matching) window.fbq('init', id, matching);
        else window.fbq('init', id);
      },
      loadGoogle(ids) {
        window.dataLayer = window.dataLayer || [];
        if (!window.gtag) {
          window.gtag = function () {
            window.dataLayer.push(arguments);
          };
          window.gtag('js', new Date());
        }
        if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ids[0])}`;
          document.head.appendChild(script);
        }
        // send_page_view off on every config: the account's Google tag may be merged with the GA4
        // tag that Shopify's Google channel already runs, and GA4 must not get a second page view.
        ids.forEach((id) => {
          const options = { send_page_view: false };
          if (id.startsWith('AW-')) options.allow_enhanced_conversions = true;
          window.gtag('config', id, options);
        });
      },
      fbq(...args) {
        try {
          if (window.fbq) window.fbq(...args);
        } catch (error) {}
      },
      gtag(...args) {
        try {
          if (window.gtag) window.gtag(...args);
        } catch (error) {}
      },
      publish(name, data) {
        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish(`mc:${name}`, data);
          }
        } catch (error) {}
      },
    };
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    customElements.define(
      'mc-funnel',
      class extends HTMLElement {
        connectedCallback() {
          this.classList.add('is-js');
          try {
            this.cfg = JSON.parse(this.querySelector('[data-config]')?.textContent || '{}');
          } catch (error) {
            this.cfg = {};
          }
          this.form = this.querySelector('form');
          if (this.querySelector('[data-thanks]')) {
            this.renderThanks();
            return;
          }
          if (!this.form || !this.querySelector('[data-step]')) return;
          ads.load(this.cfg, null);

          this.form.noValidate = true;
          this.design = Boolean(window.Shopify && window.Shopify.designMode);
          this.steps = {};
          this.querySelectorAll('[data-step]').forEach((step) => (this.steps[step.dataset.step] = step));
          this.order = ['event', 'items', 'format', 'hostess', 'people', 'date', 'contact'].filter((key) => this.steps[key]);
          this.nextBtn = this.querySelector('[data-next]');
          this.submitBtn = this.querySelector('[data-submit]');
          this.micro = this.querySelector('[data-submit-micro]');
          this.live = this.querySelector('[data-live]');
          this.bar = this.querySelector('[data-progress]');
          this.barWrap = this.querySelector('[data-progress-wrap]');
          this.scroller = this.querySelector('[data-scroll]');

          this.setupItems();
          this.setupPeople();
          this.setupDate();
          this.setupContact();
          this.prefill();

          this.addEventListener('change', (event) => this.onChange(event));
          this.addEventListener('input', (event) => this.onInput(event));
          this.addEventListener('focusout', (event) => this.onBlur(event));
          this.nextBtn?.addEventListener('click', () => this.next());
          this.querySelector('[data-back]')?.addEventListener('click', () => this.back());
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
          this.onPop = (event) => this.fromHistory(event.state);
          window.addEventListener('popstate', this.onPop);
          this.onShow = (event) => {
            if (!event.persisted) return;
            this.submitting = false;
            if (this.submitBtn) this.submitBtn.disabled = false;
          };
          window.addEventListener('pageshow', this.onShow);

          let start = this.order[0];
          const params = new URLSearchParams(window.location.search);
          // Back from Shopify's spam challenge: the answers are restored and the visitor submits again from step 7.
          const challenged = params.has('form_key') && params.get('form_type') === 'contact';
          if ((this.querySelector('[data-server-errors]') || challenged) && this.steps.contact) {
            this.restore();
            start = 'contact';
          }
          this.depth = 0;
          if (!this.design) this.saveState(start, 0, true);
          this.go(start, { focus: start === 'contact', scroll: start === 'contact', keepErrors: true });

          if (this.design) {
            this.onBlockSelect = (event) => {
              const step = event.target?.closest?.('[data-step]');
              if (step && this.contains(step)) this.go(step.dataset.step, { focus: false, scroll: false });
            };
            document.addEventListener('shopify:block:select', this.onBlockSelect);
          }
        }

        disconnectedCallback() {
          window.removeEventListener('popstate', this.onPop);
          window.removeEventListener('pageshow', this.onShow);
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        q(selector) {
          return this.querySelector(selector);
        }

        checked(name) {
          return this.form.querySelector(`input[name="${name}"]:checked`);
        }

        formatChosen() {
          return this.checked('contact[Formato]');
        }

        needsHostess() {
          return this.formatChosen()?.dataset.hostess === 'true';
        }

        visible() {
          const chosen = this.formatChosen();
          return this.order.filter((key) => key !== 'hostess' || !chosen || this.needsHostess());
        }

        saveState(step, depth, replace) {
          const state = Object.assign({}, history.state || {}, { mcStep: step, mcDepth: depth });
          if (replace) history.replaceState(state, '');
          else history.pushState(state, '');
        }

        go(key, { focus = true, scroll = true, keepErrors = false } = {}) {
          this.current = key;
          if (!keepErrors) this.clearErrors(key);
          Object.entries(this.steps).forEach(([name, step]) => step.classList.toggle('is-current', name === key));
          if (key === 'date') this.enterDate();
          this.updateUi();
          if (this.scroller) this.scroller.scrollTop = 0;
          if (scroll) {
            const top = this.getBoundingClientRect().top;
            if (top < 0) window.scrollTo({ top: window.scrollY + top });
          }
          if (focus) this.steps[key].querySelector('[data-title]')?.focus({ preventScroll: true });
        }

        updateUi() {
          const list = this.visible();
          const index = list.indexOf(this.current);
          const percent = Math.round(((index + 1) / list.length) * 100);
          if (this.bar) this.bar.style.width = `${percent}%`;
          this.barWrap?.setAttribute('aria-valuenow', String(percent));
          this.toggleAttribute('data-first', index <= 0);
          const last = index === list.length - 1;
          if (this.nextBtn) this.nextBtn.hidden = last;
          if (this.submitBtn) this.submitBtn.hidden = !last;
          if (this.micro) this.micro.hidden = !last;
          const button = last ? this.submitBtn : this.nextBtn;
          button?.setAttribute('aria-disabled', String(!this.valid(this.current)));
        }

        valid(key) {
          const step = this.steps[key];
          switch (key) {
            case 'event':
            case 'format':
            case 'hostess':
              return Boolean(step.querySelector('input[type="radio"]:checked'));
            case 'items':
              return this.items.some((box) => box.checked);
            case 'people':
              return this.people() >= (Number(this.cfg.minPeople) || 1);
            case 'date':
              return Boolean(this.dateIso) && !this.isDisabled(this.dateIso);
            case 'contact':
              return this.contactErrors().length === 0;
            default:
              return true;
          }
        }

        next() {
          if (!this.valid(this.current)) {
            this.showErrors(this.current);
            return;
          }
          const list = this.visible();
          const key = list[list.indexOf(this.current) + 1];
          if (!key) return;
          const previous = this.current;
          this.depth += 1;
          if (!this.design) this.saveState(key, this.depth, false);
          this.go(key);
          this.track('step', { step: key, index: list.indexOf(key) + 1, total: list.length, from: previous });
          if (previous === this.order[0]) this.trackStart();
        }

        back() {
          if (!this.design && this.depth > 0) {
            history.back();
            return;
          }
          const list = this.visible();
          const index = list.indexOf(this.current);
          if (index <= 0) return;
          const key = list[index - 1];
          if (!this.design) this.saveState(key, 0, true);
          this.go(key);
        }

        fromHistory(state) {
          if (!state || !state.mcStep || !this.steps[state.mcStep]) return;
          this.depth = Number(state.mcDepth) || 0;
          const list = this.visible();
          let key = state.mcStep;
          if (!list.includes(key)) key = 'format';
          const invalid = list.slice(0, list.indexOf(key)).find((name) => !this.valid(name));
          this.go(invalid || key);
        }

        showErrors(key) {
          this.clearErrors(key);
          const messages = [];
          if (key === 'contact') {
            const errors = this.contactErrors();
            errors.forEach(([input, message]) => {
              this.markField(input, message);
              messages.push(message);
            });
            errors[0]?.[0].focus();
          } else if (key === 'people') {
            this.markField(this.peopleInput, this.cfg.errPeople);
            messages.push(this.cfg.errPeople);
            this.peopleInput.focus();
          } else {
            const box = this.steps[key].querySelector('[data-error]');
            if (box) {
              box.querySelector('[data-error-text]').textContent = this.cfg.errChoice;
              box.hidden = false;
            }
            messages.push(this.cfg.errChoice);
          }
          if (this.live) {
            this.live.textContent = '';
            window.setTimeout(() => (this.live.textContent = messages.join(' ')), 50);
          }
        }

        markField(input, message) {
          const field = input?.closest('[data-field]');
          if (!field) return;
          field.classList.add('is-invalid');
          input.setAttribute('aria-invalid', 'true');
          const box = field.querySelector('[data-field-error]');
          if (box) {
            box.querySelector('[data-error-text]').textContent = message;
            box.hidden = false;
          }
        }

        clearField(input) {
          const field = input?.closest('[data-field]');
          if (!field) return;
          field.classList.remove('is-invalid');
          input.removeAttribute('aria-invalid');
          const box = field.querySelector('[data-field-error]');
          if (box) box.hidden = true;
        }

        clearErrors(key) {
          const step = this.steps[key];
          if (!step) return;
          step.querySelectorAll('[data-error]').forEach((box) => (box.hidden = true));
          step.querySelectorAll('.is-invalid input, .is-invalid textarea').forEach((input) => this.clearField(input));
        }

        refreshErrors() {
          const key = this.current;
          const step = this.steps[key];
          if (!step) return;
          if (key === 'contact') {
            const bad = this.contactErrors().map(([input]) => input);
            step.querySelectorAll('.is-invalid input, .is-invalid textarea').forEach((input) => {
              if (!bad.includes(input)) this.clearField(input);
            });
          } else if (this.valid(key)) {
            this.clearErrors(key);
          }
        }

        onChange(event) {
          const target = event.target;
          if (target.name === 'contact[Formato]' && !this.needsHostess()) {
            this.steps.hostess?.querySelectorAll('input').forEach((input) => (input.checked = false));
          }
          if (target.name === 'contact[Tipo di evento]') this.updateDateTitle();
          if (target.matches('[data-item]')) this.onItem(target);
          this.refreshErrors();
          this.updateUi();
        }

        onInput(event) {
          const target = event.target;
          if (target === this.peopleInput) {
            const clean = target.value.replace(/\D+/g, '');
            if (clean !== target.value) target.value = clean;
            this.updateDateHelper();
            if (this.dateIso && this.isDisabled(this.dateIso)) this.setDate('');
          }
          this.refreshErrors();
          this.updateUi();
        }

        onBlur(event) {
          const target = event.target;
          if (target === this.emailInput && target.value.trim() && !EMAIL_RE.test(target.value.trim())) {
            this.markField(target, this.cfg.errEmail);
          }
        }

        setupItems() {
          this.items = Array.from(this.querySelectorAll('[data-item]'));
          this.joined = this.q('[data-items-joined]');
          if (!this.joined) return;
          this.items.forEach((box) => box.removeAttribute('name'));
          this.joined.name = this.joined.dataset.joinedName;
        }

        onItem(box) {
          if (box.checked) {
            const exclusive = box.dataset.exclusive === 'true';
            this.items.forEach((other) => {
              if (other === box) return;
              if (exclusive || other.dataset.exclusive === 'true') other.checked = false;
            });
          }
          if (this.joined) this.joined.value = this.selectedItems().join(', ');
        }

        selectedItems() {
          return this.items.filter((box) => box.checked).map((box) => box.value);
        }

        setupPeople() {
          this.peopleInput = this.q('[data-people]');
        }

        people() {
          return parseInt(this.peopleInput?.value || '', 10) || 0;
        }

        big() {
          return this.people() >= (Number(this.cfg.bigFrom) || Infinity);
        }

        setupDate() {
          this.cal = this.q('[data-calendar]');
          this.dateHidden = this.q('[data-date-value]');
          const native = this.q('[data-native-date]');
          if (!this.cal || !this.dateHidden || !native) return;
          native.removeAttribute('name');
          native.required = false;
          this.q('[data-native-wrap]').hidden = true;
          this.dateHidden.name = 'contact[Data]';
          this.cal.hidden = false;
          this.today = this.romeToday();
          const today = new Date(this.today);
          this.view = { y: today.getUTCFullYear(), m: today.getUTCMonth() };
          this.monthFmt = new Intl.DateTimeFormat('it-IT', { month: 'long', year: 'numeric', timeZone: 'UTC' });
          this.longFmt = new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
          this.fullFmt = new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
          this.q('[data-cal-prev]').addEventListener('click', () => this.shiftMonth(-1));
          this.q('[data-cal-next]').addEventListener('click', () => this.shiftMonth(1));
          this.q('[data-cal-grid]').addEventListener('click', (event) => {
            const day = event.target.closest('[data-date]');
            if (day && !day.disabled) this.setDate(day.dataset.date);
          });
          this.updateDateTitle();
          this.updateDateHelper();
        }

        romeToday() {
          const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Europe/Rome',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }).formatToParts(new Date());
          const get = (type) => Number(parts.find((part) => part.type === type).value);
          return Date.UTC(get('year'), get('month') - 1, get('day'));
        }

        minTime() {
          const days = this.big() ? Number(this.cfg.leadBig) || 0 : Number(this.cfg.lead) || 0;
          return this.today + days * DAY;
        }

        iso(time) {
          return new Date(time).toISOString().slice(0, 10);
        }

        timeOf(iso) {
          return Date.parse(`${iso}T00:00:00Z`);
        }

        isDisabled(iso) {
          return !this.today || this.timeOf(iso) < this.minTime();
        }

        enterDate() {
          if (!this.cal) return;
          if (this.dateIso && this.isDisabled(this.dateIso)) this.setDate('', false);
          const base = new Date(this.dateIso ? this.timeOf(this.dateIso) : this.minTime());
          this.view = { y: base.getUTCFullYear(), m: base.getUTCMonth() };
          this.updateDateTitle();
          this.updateDateHelper();
          this.renderCalendar();
        }

        shiftMonth(delta) {
          const date = new Date(Date.UTC(this.view.y, this.view.m + delta, 1));
          this.view = { y: date.getUTCFullYear(), m: date.getUTCMonth() };
          this.renderCalendar();
        }

        renderCalendar() {
          if (!this.cal) return;
          const { y, m } = this.view;
          const first = Date.UTC(y, m, 1);
          const offset = (new Date(first).getUTCDay() + 6) % 7;
          const count = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
          const trailing = (7 - ((offset + count) % 7)) % 7;
          const grid = this.q('[data-cal-grid]');
          const label = this.monthFmt.format(new Date(first));
          this.q('[data-cal-label]').textContent = label.charAt(0).toUpperCase() + label.slice(1);
          const today = new Date(this.today);
          const current = today.getUTCFullYear() * 12 + today.getUTCMonth();
          this.q('[data-cal-prev]').disabled = y * 12 + m <= current;
          this.q('[data-cal-next]').disabled = y * 12 + m >= current + 12;
          const cells = [];
          for (let i = 0; i < offset; i++) cells.push(document.createElement('span'));
          for (let d = 1; d <= count + trailing; d++) {
            const time = Date.UTC(y, m, d);
            const iso = this.iso(time);
            const button = document.createElement('button');
            const inner = document.createElement('span');
            button.type = 'button';
            button.className = 'mc-funnel-cal__day';
            if (d > count) button.classList.add('mc-funnel-cal__day--other');
            if (time === this.today) button.classList.add('mc-funnel-cal__day--today');
            button.dataset.date = iso;
            button.disabled = this.isDisabled(iso);
            button.setAttribute('aria-pressed', String(iso === this.dateIso));
            button.setAttribute('aria-label', this.fullFmt.format(new Date(time)));
            inner.textContent = String(new Date(time).getUTCDate());
            button.append(inner);
            cells.push(button);
          }
          grid.replaceChildren(...cells);
        }

        setDate(iso, render = true) {
          this.dateIso = iso;
          if (this.dateHidden) {
            if (iso) {
              const [year, month, day] = iso.split('-');
              this.dateHidden.value = `${day}/${month}/${year}`;
            } else {
              this.dateHidden.value = '';
            }
          }
          if (render) {
            this.renderCalendar();
            this.refreshErrors();
            this.updateUi();
          }
        }

        dateLabel() {
          if (!this.dateIso || !this.longFmt) return this.dateHidden?.value || '';
          const text = this.longFmt.format(new Date(this.timeOf(this.dateIso)));
          return text.charAt(0).toUpperCase() + text.slice(1);
        }

        updateDateTitle() {
          const title = this.q('[data-date-heading]');
          if (!title) return;
          const event = this.checked('contact[Tipo di evento]');
          title.textContent = event?.dataset.dateTitle || this.cfg.dateTitle || title.textContent;
        }

        updateDateHelper() {
          const helper = this.q('[data-date-helper]');
          if (!helper) return;
          helper.textContent = this.big() && this.cfg.dateHelperBig ? this.cfg.dateHelperBig : this.cfg.dateHelper;
        }

        setupContact() {
          this.nameInput = this.q('[data-name]');
          this.emailInput = this.q('[data-email]');
          this.consent = this.q('[data-consent]');
          this.marketing = this.q('[data-marketing]');
          this.hp = this.q('[data-hp]');
          this.querySelectorAll('.mc-funnel-consent__text a, .mc-funnel__legal a').forEach((link) => {
            link.target = '_blank';
            link.rel = 'noopener';
          });
        }

        contactErrors() {
          const errors = [];
          if (this.nameInput && !this.nameInput.value.trim()) errors.push([this.nameInput, this.cfg.errName]);
          if (this.emailInput && !EMAIL_RE.test(this.emailInput.value.trim())) errors.push([this.emailInput, this.cfg.errEmail]);
          if (this.consent && !this.consent.checked) errors.push([this.consent, this.cfg.errConsent]);
          return errors;
        }

        prefill() {
          const key = new URLSearchParams(window.location.search).get('formato');
          if (!key) return;
          const option = Array.from(this.querySelectorAll('input[name="contact[Formato]"]')).find(
            (input) => input.dataset.key && input.dataset.key === key.toLowerCase()
          );
          if (option) option.checked = true;
        }

        answers() {
          const value = (name) => this.checked(name)?.value || '';
          const hostess = this.needsHostess() ? this.checked('contact[Hostess]') : null;
          return {
            evento: value('contact[Tipo di evento]'),
            cosa: this.selectedItems(),
            formato: value('contact[Formato]'),
            hostess: hostess ? hostess.value : '',
            hostessYes: Boolean(hostess && hostess.hasAttribute('data-yes')),
            persone: this.peopleInput?.value || '',
            data: this.dateHidden?.value || '',
            dataIso: this.dateIso || '',
            dataLabel: this.dateLabel(),
            orario: value('contact[Orario]'),
          };
        }

        restore() {
          let saved = null;
          try {
            saved = JSON.parse(sessionStorage.getItem(RECAP_KEY));
          } catch (error) {}
          if (!saved) return;
          const pick = (name, val) => {
            if (!val) return;
            const input = Array.from(this.querySelectorAll(`input[name="${name}"]`)).find((item) => item.value === val);
            if (input) input.checked = true;
          };
          pick('contact[Tipo di evento]', saved.evento);
          pick('contact[Formato]', saved.formato);
          pick('contact[Hostess]', saved.hostess);
          (saved.cosa || []).forEach((label) => {
            const box = this.items.find((item) => item.value === label);
            if (box) box.checked = true;
          });
          if (this.joined) this.joined.value = this.selectedItems().join(', ');
          if (this.peopleInput && saved.persone) this.peopleInput.value = saved.persone;
          if (saved.dataIso && this.cal) this.setDate(saved.dataIso, false);
          this.updateDateTitle();
          this.updateDateHelper();
        }

        stop(event) {
          // Shopify's spam protection listens on document and calls form.submit() even after preventDefault.
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        onSubmit(event) {
          if (this.submitting) return;
          if (this.hp && this.hp.value) {
            this.stop(event);
            return;
          }
          const invalid = this.visible().find((key) => !this.valid(key));
          if (invalid) {
            this.stop(event);
            if (invalid !== this.current) this.go(invalid);
            this.showErrors(invalid);
            return;
          }
          this.submitting = true;
          const answers = this.answers();
          let draft = null;
          try {
            draft = this.leadDraft(answers);
            sessionStorage.setItem(LEAD_KEY, JSON.stringify(draft));
          } catch (error) {}
          try {
            sessionStorage.setItem(
              RECAP_KEY,
              JSON.stringify({
                evento: answers.evento,
                cosa: answers.cosa,
                formato: answers.formato,
                hostess: answers.hostess,
                hostessYes: answers.hostessYes,
                persone: answers.persone,
                dataIso: answers.dataIso,
                dataLabel: answers.dataLabel,
              })
            );
          } catch (error) {}
          try {
            this.sendKlaviyo(answers, draft);
          } catch (error) {}
          window.setTimeout(() => {
            if (this.submitBtn) this.submitBtn.disabled = true;
          }, 0);
        }

        italianPhone(raw) {
          let phone = raw.replace(/[\s.\-()/]/g, '');
          if (phone.startsWith('00')) phone = `+${phone.slice(2)}`;
          if (phone.startsWith('+')) return /^\+39\d{6,11}$/.test(phone) ? phone : '';
          if (/^3\d{8,9}$/.test(phone) || /^0\d{5,10}$/.test(phone)) return `+39${phone}`;
          return '';
        }

        sendKlaviyo(answers, draft) {
          const text = (selector) => this.q(selector)?.value.trim() || '';
          const name = text('[data-name]');
          const [firstName, ...rest] = name.split(/\s+/);
          const email = text('[data-email]');
          const sent = `${email.toLowerCase()}|${answers.dataIso}`;
          try {
            if (sessionStorage.getItem(KLAVIYO_KEY) === sent) return;
            sessionStorage.setItem(KLAVIYO_KEY, sent);
          } catch (error) {}
          const company = text('[data-company]');
          const phoneRaw = text('[data-phone]');
          const phone = this.italianPhone(phoneRaw);
          const marketing = this.cfg.double ? Boolean(this.marketing?.checked) : true;
          const properties = {
            'Tipo di evento': answers.evento,
            'Cosa portiamo': answers.cosa.join(', '),
            Formato: answers.formato,
            Hostess: answers.hostess,
            Persone: answers.persone ? Number(answers.persone) : '',
            Data: answers.data,
            Orario: answers.orario,
            Dove: text('[data-address]'),
            Note: text('[data-notes]'),
            'Società': company,
            'Numero di telefono': phoneRaw,
            'ID evento': draft ? draft.event_id : '',
            'Valore lead': draft ? draft.value : '',
            gclid: draft && draft.click ? draft.click.gclid : '',
            gbraid: draft && draft.click ? draft.click.gbraid : '',
            wbraid: draft && draft.click ? draft.click.wbraid : '',
            fbclid: draft && draft.click ? draft.click.fbclid : '',
            fbp: draft && draft.click ? draft.click.fbp : '',
            fbc: draft && draft.click ? draft.click.fbc : '',
          };
          Object.keys(properties).forEach((key) => {
            if (properties[key] === '' || properties[key] === undefined) delete properties[key];
          });

          const profile = { email, first_name: firstName || undefined, last_name: rest.join(' ') || undefined };
          if (company) profile.organization = company;
          const queue = window.klaviyo || (window._klOnsite = window._klOnsite || []);
          queue.push(['identify', profile]);
          queue.push([
            'track',
            this.cfg.klEvent || 'Richiesta catering',
            Object.assign({}, properties, { 'Consenso marketing': marketing ? 'Sì' : 'No' }),
          ]);

          if (!marketing || !this.cfg.klKey || !this.cfg.klList) return;
          const attributes = {
            email,
            properties: Object.assign({}, properties, { 'Richiesta catering': true }),
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
          };
          if (firstName) attributes.first_name = firstName;
          if (rest.length) attributes.last_name = rest.join(' ');
          if (company) attributes.organization = company;
          if (phone) attributes.phone_number = phone;
          fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.cfg.klKey)}`, {
            method: 'POST',
            keepalive: true,
            headers: {
              'Content-Type': 'application/vnd.api+json',
              Accept: 'application/vnd.api+json',
              revision: '2026-07-15',
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: `Funnel catering (${this.cfg.klSource || 'Catering'})`,
                  profile: { data: { type: 'profile', attributes } },
                },
                relationships: { list: { data: { type: 'list', id: this.cfg.klList } } },
              },
            }),
          }).catch(() => {});
        }

        track(name, data) {
          if (!this.cfg.track || this.design || designMode()) return;
          const payload = data || {};
          ads.publish(`catering_${name}`, payload);
          const custom = { funnel_start: 'CateringFunnelStart', step: 'CateringStep' }[name];
          if (custom) ads.fbq('trackCustom', custom, payload);
        }

        trackStart() {
          try {
            if (sessionStorage.getItem(START_KEY)) return;
            sessionStorage.setItem(START_KEY, '1');
          } catch (error) {}
          this.track('funnel_start', { page: this.cfg.pageUrl || '' });
        }

        leadDraft(answers) {
          const text = (selector) => this.q(selector)?.value.trim() || '';
          const name = text('[data-name]');
          const [firstName, ...rest] = name.split(/\s+/);
          const email = text('[data-email]').toLowerCase();
          const people = Number(answers.persone) || 0;
          const perPerson = Number(this.cfg.valuePerPerson) || 0;
          let click = {};
          let previous = null;
          try {
            click = JSON.parse(sessionStorage.getItem(CLICK_KEY) || '{}') || {};
            previous = JSON.parse(sessionStorage.getItem(LEAD_KEY));
          } catch (error) {}
          const sameLead = previous && previous.user && previous.user.email === email;
          return {
            event_id: sameLead && previous.event_id ? previous.event_id : uuid(),
            value: Math.round(people * perPerson * 100) / 100,
            currency: 'EUR',
            value_per_person: perPerson,
            people,
            event_type: answers.evento || '',
            items: answers.cosa || [],
            format: answers.formato || '',
            hostess: answers.hostess || '',
            date: answers.dataIso || '',
            page: this.cfg.pageUrl || '',
            user: {
              email,
              phone: this.italianPhone(text('[data-phone]')),
              first_name: firstName || '',
              last_name: rest.join(' '),
            },
            click: {
              gclid: click.gclid || '',
              gbraid: click.gbraid || '',
              wbraid: click.wbraid || '',
              fbclid: click.fbclid || '',
              fbp: cookie('_fbp'),
              fbc: cookie('_fbc'),
            },
          };
        }

        // Runs on the thank-you page (after Shopify confirmed the submit). One Lead per request:
        // the draft saved at submit carries the event id, and the id is remembered once sent.
        sendLead() {
          if (!this.cfg.track || designMode()) return;
          let draft = null;
          try {
            draft = JSON.parse(sessionStorage.getItem(LEAD_KEY));
          } catch (error) {}
          if (!draft || !draft.event_id) return;
          let sent = '';
          try {
            sent = sessionStorage.getItem(LEAD_SENT_KEY) || '';
          } catch (error) {}
          if (sent === draft.event_id) return;
          try {
            sessionStorage.setItem(LEAD_SENT_KEY, draft.event_id);
            sessionStorage.removeItem(LEAD_KEY);
          } catch (error) {}

          const user = this.cfg.sendContact && draft.user ? draft.user : null;
          const matching = {};
          if (user) {
            if (user.email) matching.em = user.email;
            if (user.phone) matching.ph = user.phone.replace(/\D/g, '');
            if (user.first_name) matching.fn = user.first_name.toLowerCase();
            if (user.last_name) matching.ln = user.last_name.toLowerCase();
          }
          ads.load(this.cfg, Object.keys(matching).length ? matching : null);

          ads.fbq(
            'track',
            'Lead',
            {
              content_name: 'Richiesta catering',
              content_category: 'catering',
              value: draft.value,
              currency: 'EUR',
              num_people: draft.people,
              event_type: draft.event_type,
              format: draft.format,
              hostess: draft.hostess,
            },
            { eventID: draft.event_id }
          );

          if (user && user.email) {
            const data = { email: user.email };
            if (user.phone) data.phone_number = user.phone;
            if (user.first_name || user.last_name) {
              data.address = { first_name: user.first_name, last_name: user.last_name };
            }
            ads.gtag('set', 'user_data', data);
          }
          if (this.cfg.googleAds && this.cfg.googleLabel) {
            ads.gtag('event', 'conversion', {
              send_to: `${this.cfg.googleAds}/${this.cfg.googleLabel}`,
              value: draft.value,
              currency: 'EUR',
              transaction_id: draft.event_id,
            });
          }
          if (this.cfg.ga4) {
            ads.gtag('event', 'generate_lead', {
              send_to: this.cfg.ga4,
              value: draft.value,
              currency: 'EUR',
              lead_source: 'Funnel catering',
              event_type: draft.event_type,
              people: draft.people,
            });
          }

          const payload = Object.assign({}, draft);
          if (!user) delete payload.user;
          ads.publish('catering_lead', payload);
        }

        renderThanks() {
          let saved = null;
          try {
            saved = JSON.parse(sessionStorage.getItem(RECAP_KEY));
          } catch (error) {}
          const card = this.q('[data-recap]');
          const list = this.q('[data-recap-list]');
          const labels = this.cfg.recap || {};
          if (saved && card && list) {
            let format = saved.formato || '';
            if (format && saved.hostess) format += saved.hostessYes ? labels.hostessYes || '' : labels.hostessNo || '';
            const rows = [
              [labels.evento, saved.evento],
              [labels.cosa, (saved.cosa || []).join(', ')],
              [labels.formato, format],
              [labels.persone, saved.persone],
              [labels.data, saved.dataLabel],
            ].filter(([label, value]) => label && value);
            rows.forEach(([label, value]) => {
              const row = document.createElement('div');
              const term = document.createElement('dt');
              const detail = document.createElement('dd');
              row.className = 'mc-funnel__recap-row';
              term.textContent = label;
              detail.textContent = value;
              row.append(term, detail);
              list.append(row);
            });
            card.hidden = rows.length === 0;
          }
          try {
            this.sendLead();
          } catch (error) {}
          try {
            sessionStorage.removeItem(RECAP_KEY);
            sessionStorage.removeItem(KLAVIYO_KEY);
          } catch (error) {}
          if (!(window.Shopify && window.Shopify.designMode)) {
            this.q('[data-title]')?.focus({ preventScroll: true });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-mc-cta-to-atc]');
    if (!link) return;
    const button = document.querySelector('[data-mc-atc]');
    if (!button) return;
    event.preventDefault();
    button.scrollIntoView({ behavior: 'smooth', block: 'center' });
    button.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-buy-box"]) return;
  try {
    
  if (!customElements.get('mc-gallery')) {
    customElements.define(
      'mc-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index() - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index() + 1));
          this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(Number(thumb.dataset.thumb))));
          this.track?.addEventListener('scroll', () => this.sync(), { passive: true });
        }
        index() {
          return Math.round(this.track.scrollLeft / this.track.clientWidth);
        }
        go(i) {
          const count = this.track.children.length;
          const target = (i + count) % count;
          this.track.scrollTo({ left: target * this.track.clientWidth });
        }
        sync() {
          const current = this.index();
          this.thumbs.forEach((thumb, i) => {
            if (i === current) {
              thumb.setAttribute('aria-current', 'true');
              thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            } else {
              thumb.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }
  if (!customElements.get('mc-variant-picker')) {
    customElements.define(
      'mc-variant-picker',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-mc-variants]').textContent);
          this.form = document.getElementById(this.dataset.form);
          this.root = this.closest('.mc-buy-box');
          this.addEventListener('change', () => this.update());
          this.markAvailability();
        }
        selected() {
          return Array.from(this.querySelectorAll('fieldset')).map((set) => set.querySelector('input:checked')?.value ?? null);
        }
        update() {
          const selected = this.selected();
          this.querySelectorAll('fieldset').forEach((set, i) => {
            const label = set.querySelector('[data-mc-option-selected]');
            if (label) label.textContent = selected[i] ?? '';
          });
          const variant = this.variants.find((item) => item.options.every((value, i) => value === selected[i]));
          const available = Boolean(variant && variant.available);
          if (variant) {
            this.form.querySelector('[data-mc-variant-id]').value = variant.id;
            this.root.querySelectorAll('[data-mc-price], [data-mc-sticky-price]').forEach((el) => (el.textContent = variant.price));
            const compare = this.root.querySelector('[data-mc-compare]');
            if (compare) {
              compare.textContent = variant.compare || '';
              compare.hidden = !variant.compare;
            }
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
            const slide = variant.media && this.root.querySelector(`[data-media-id="${variant.media}"]`);
            if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft });
          }
          this.root.querySelectorAll('[data-mc-atc], [data-mc-sticky-atc]').forEach((button) => {
            button.disabled = !available;
            button.textContent = available ? this.dataset.add : this.dataset.sold;
          });
          this.markAvailability();
        }
        markAvailability() {
          const selected = this.selected();
          this.querySelectorAll('fieldset').forEach((set, i) => {
            set.querySelectorAll('input').forEach((input) => {
              const open = this.variants.some(
                (item) =>
                  item.available &&
                  item.options[i] === input.value &&
                  item.options.every((value, j) => j === i || selected[j] === null || value === selected[j])
              );
              input.closest('.mc-pill').classList.toggle('is-unavailable', !open);
            });
          });
        }
      }
    );
  }

  if (!customElements.get('mc-quantity')) {
    customElements.define(
      'mc-quantity',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.querySelectorAll('[data-step]').forEach((button) =>
            button.addEventListener('click', () => {
              const next = Math.max(1, (parseInt(this.input.value, 10) || 1) + Number(button.dataset.step));
              this.input.value = next;
            })
          );
          this.input.addEventListener('change', () => {
            if (!(parseInt(this.input.value, 10) >= 1)) this.input.value = 1;
          });
        }
      }
    );
  }

  if (!customElements.get('mc-sticky-atc')) {
    customElements.define(
      'mc-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          const form = document.getElementById(this.dataset.form);
          const target = form?.querySelector('.mc-buy-row') || form;
          if (!target) return;
          this.observer = new IntersectionObserver(([entry]) => {
            this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
          });
          this.observer.observe(target);
        }
        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-ugc')) {
    customElements.define(
      'mc-ugc',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.bar = this.querySelector('[data-progress]');
          this.dialog = this.querySelector('[data-player]');
          this.player = this.querySelector('[data-player-video]');
          this.items = Array.from(this.querySelectorAll('[data-ugc-video]'));
          this.previews = Array.from(this.querySelectorAll('[data-preview]'));
          this.seconds = Number(this.dataset.previewSeconds) || 5;
          this.muted = false;
          this.current = 0;
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.track?.addEventListener('scroll', () => this.progress(), { passive: true });
          window.addEventListener('resize', () => this.progress());
          this.progress();

          this.querySelectorAll('[data-mc-to-atc]').forEach((link) =>
            link.addEventListener('click', (event) => this.toCart(event))
          );

          this.hlsReady = document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '';
          this.previews.forEach((video) => {
            video.muted = true;
            video.addEventListener('timeupdate', () => {
              if (video.currentTime >= this.seconds) video.currentTime = 0;
            });
            video.addEventListener('ended', () => {
              video.currentTime = 0;
              video.play().catch(() => {});
            });
          });

          if (this.reduce || !('IntersectionObserver' in window)) {
            this.classList.add('mc-ugc--static');
          } else {
            this.observer = new IntersectionObserver(
              (entries) =>
                entries.forEach((entry) => {
                  const video = entry.target;
                  video.inView = entry.isIntersecting;
                  if (!entry.isIntersecting) {
                    video.pause();
                    return;
                  }
                  this.prepare(video).then(() => {
                    if (video.inView && !this.dialog?.open) video.play().catch(() => {});
                  });
                }),
              { threshold: 0.6 }
            );
            this.previews.forEach((video) => this.observer.observe(video));
          }

          this.items.forEach((item, index) =>
            item.querySelector('[data-open]')?.addEventListener('click', () => this.open(index))
          );

          if (!this.dialog) return;
          this.dialog.classList.toggle('is-single', this.items.length < 2);
          this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.querySelector('[data-mute]').addEventListener('click', () => this.setMuted(!this.muted));
          this.dialog.querySelector('[data-player-prev]').addEventListener('click', () => this.show(this.current - 1));
          this.dialog.querySelector('[data-player-next]').addEventListener('click', () => this.show(this.current + 1));
          this.dialog.querySelector('[data-player-cart]').addEventListener('click', (event) => {
            this.dialog.close();
            if (!this.dataset.targetUrl) this.toCart(event);
          });
          this.player.addEventListener('click', () => this.toggle());
          this.player.addEventListener('play', () => this.dialog.classList.remove('is-paused'));
          this.player.addEventListener('pause', () => this.dialog.classList.add('is-paused'));
          this.player.addEventListener('timeupdate', () => {
            const fill = this.dialog.querySelector('[data-player-progress]');
            if (fill && this.player.duration) fill.style.width = `${(this.player.currentTime / this.player.duration) * 100}%`;
          });
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
              event.preventDefault();
              this.show(this.current + 1);
            }
            if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
              event.preventDefault();
              this.show(this.current - 1);
            }
          });
          this.dialog.addEventListener('close', () => this.onClose());
          let startX = 0;
          let startY = 0;
          const stage = this.dialog.querySelector('[data-stage]');
          stage.addEventListener('touchstart', (event) => {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          }, { passive: true });
          stage.addEventListener('touchend', (event) => {
            const dx = event.changedTouches[0].clientX - startX;
            const dy = event.changedTouches[0].clientY - startY;
            if (Math.abs(dy) > 50 && Math.abs(dy) > Math.abs(dx)) this.show(this.current + (dy < 0 ? 1 : -1));
          }, { passive: true });
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        async variants(hls) {
          this.variantCache = this.variantCache || {};
          if (!this.variantCache[hls]) {
            this.variantCache[hls] = (async () => {
              const master = new URL(hls, window.location.href);
              const lines = (await (await fetch(master)).text()).split('\n');
              const list = [];
              lines.forEach((line, i) => {
                const uri = (lines[i + 1] || '').trim();
                if (!line.startsWith('#EXT-X-STREAM-INF') || !uri || uri.startsWith('#')) return;
                const size = line.match(/RESOLUTION=(\d+)x(\d+)/);
                const short = size ? Math.min(Number(size[1]), Number(size[2])) : 0;
                list.push({ short, url: new URL(uri, master).href });
              });
              return list.sort((a, b) => a.short - b.short);
            })().catch(() => []);
          }
          return this.variantCache[hls];
        }

        prepare(video) {
          if (!video.ready) {
            video.ready = (async () => {
              if (!this.hlsReady || !video.dataset.hls) return;
              const list = await this.variants(video.dataset.hls);
              const card = video.closest('[data-ugc-video]');
              if (card) card.variants = list;
              if (!list.length) {
                video.src = video.dataset.hls;
                return;
              }
              const variant = list[0].url;
              const trimmed = await this.trim(variant);
              if (trimmed) {
                video.addEventListener('error', () => {
                  if (video.src !== variant) {
                    video.src = variant;
                    if (video.inView) video.play().catch(() => {});
                  }
                }, { once: true });
                video.src = trimmed;
              } else {
                video.src = variant;
              }
            })();
          }
          return video.ready;
        }

        async trim(variant) {
          try {
            const lines = (await (await fetch(variant)).text()).split('\n');
            if (!lines.some((line) => line.trim() === '#EXT-X-ENDLIST')) return null;
            const out = [];
            let total = 0;
            for (let i = 0; i < lines.length; i++) {
              const line = lines[i].trim();
              if (!line) continue;
              if (line.startsWith('#EXTINF')) {
                const uri = (lines[i + 1] || '').trim();
                out.push(line, new URL(uri, variant).href);
                total += parseFloat(line.split(':')[1]) || 0;
                i++;
                if (total >= this.seconds) break;
              } else if (line.startsWith('#EXT-X-ENDLIST')) {
                break;
              } else if (/^#EXT-X-(KEY|MAP)/.test(line)) {
                out.push(line.replace(/URI="([^"]+)"/, (all, uri) => `URI="${new URL(uri, variant).href}"`));
              } else if (!line.startsWith('#')) {
                out.push(new URL(line, variant).href);
              } else {
                out.push(line);
              }
            }
            out.push('#EXT-X-ENDLIST');
            return URL.createObjectURL(new Blob([out.join('\n')], { type: 'application/vnd.apple.mpegurl' }));
          } catch (error) {
            return null;
          }
        }

        open(index) {
          this.previews.forEach((video) => video.pause());
          if (this.hlsReady) {
            this.items.forEach((item) => {
              if (!item.variants && item.dataset.hls) {
                this.variants(item.dataset.hls).then((list) => {
                  item.variants = list;
                });
              }
            });
          }
          this.scrollY = window.scrollY;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.show(index);
        }

        show(index) {
          const count = this.items.length;
          if (!count) return;
          this.current = ((index % count) + count) % count;
          const item = this.items[this.current];
          const canHls = item.dataset.hls && this.player.canPlayType('application/vnd.apple.mpegurl');
          this.player.poster = item.dataset.poster || '';
          let source = canHls ? item.dataset.hls : item.dataset.full;
          if (canHls && window.innerWidth < 990 && item.variants?.length) {
            const capped = item.variants.filter((variant) => variant.short <= 404).pop();
            if (capped) source = capped.url;
          }
          this.player.src = source;
          this.setMuted(this.muted);
          const handle = this.dialog.querySelector('[data-player-handle]');
          handle.textContent = item.dataset.handle || '';
          if (item.dataset.link) handle.setAttribute('href', item.dataset.link);
          else handle.removeAttribute('href');
          const fill = this.dialog.querySelector('[data-player-progress]');
          if (fill) fill.style.width = '0%';
          this.player.play().catch(() => {
            this.setMuted(true);
            this.player.play().catch(() => this.dialog.classList.add('is-paused'));
          });
        }

        toggle() {
          if (this.player.paused) this.player.play().catch(() => {});
          else this.player.pause();
        }

        setMuted(value) {
          this.muted = value;
          this.player.muted = value;
          this.dialog.classList.toggle('is-muted', value);
          const button = this.dialog.querySelector('[data-mute]');
          button.setAttribute('aria-pressed', String(value));
        }

        onClose() {
          this.player.pause();
          this.player.removeAttribute('src');
          this.player.load();
          document.documentElement.style.overflow = '';
          if (!this.reduce) {
            this.previews.forEach((video) => {
              if (video.inView) this.prepare(video).then(() => video.play().catch(() => {}));
            });
          }
        }

        toCart(event) {
          const button = document.querySelector('[data-mc-atc]');
          if (!button) return;
          event.preventDefault();
          button.scrollIntoView({ behavior: 'smooth', block: 'center' });
          button.focus({ preventScroll: true });
        }

        progress() {
          if (!this.track || !this.bar) return;
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const visible = scrollWidth > 0 ? clientWidth / scrollWidth : 1;
          const width = Math.max(visible * 100, 8);
          const max = scrollWidth - clientWidth;
          const ratio = max > 0 ? scrollLeft / max : 0;
          this.bar.style.width = `${width}%`;
          this.bar.style.left = `${ratio * (100 - width)}%`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
